import { render, staticRenderFns } from "./dashTable.vue?vue&type=template&id=3348241d&"
import script from "./dashTable.vue?vue&type=script&lang=js&"
export * from "./dashTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports